import { CustomerForm } from '../types/customerForm'
import { ShippingAddress } from '../types/shippingAddress'

export const getCreateShippingAddressPayload = (
  customerFormValues: CustomerForm,
  organizationId: string | undefined,
): ShippingAddress => {
  const { shippingAddress } = customerFormValues

  return {
    ...(shippingAddress?.id && { id: shippingAddress?.id }),
    addressLine1: shippingAddress?.streetAddress1,
    addressLine2: shippingAddress?.streetAddress2,
    city: shippingAddress?.city,
    countryId: shippingAddress?.country,
    organizationId,
    zipcode: shippingAddress?.pobox,
  }
}
